import { usePublicLang } from "@/contexts/PublicLangContext";
import ScrollReveal from "./ScrollReveal";

// Fix D (2026-09-09): cifras de respaldo pedidas por la clinica para generar
// confianza. Valores fijos acordados con SJB; si en el futuro hay que
// editarlos desde el panel, se migran a LandingSettings.
const STATS = [
  { value: "+25", key: "years" },
  { value: "+1000", key: "patients" },
  { value: "+5000", key: "treatments" },
];

export default function StatsSection() {
  const { t } = usePublicLang();
  return (
    <section className="py-16 md:py-20 px-5" style={{ backgroundColor: "var(--brand-secondary)" }} data-testid="landing-stats">
      <ScrollReveal className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-6 text-center">
        {STATS.map((s) => (
          <div key={s.key} className="flex flex-col items-center gap-2">
            <span className="font-serif text-4xl md:text-5xl text-[var(--brand-primary)]">{s.value}</span>
            <span className="text-[11px] uppercase tracking-[0.18em] text-[#6B6058]">{t(`landing.stats.${s.key}`)}</span>
          </div>
        ))}
      </ScrollReveal>
    </section>
  );
}
